export const SET_ALL_RESTRAINERS = 'SET_ALL_RESTRAINERS';
export const ADD_RESTRAINER = 'ADD_RESTRAINER';
export const SET_FILTERS = 'SET_FILTERS';
